module.exports = __webpack_public_path__ + "img/img07.f0707a12.jpeg";